import type { RouteRecordRaw, Router } from 'vue-router'

const courtOfJusticeRoutes: RouteRecordRaw = {
  path: '/claim/court-of-justice',
  redirect: { name: 'CourtOfJusticeView' },
  children: [
    {
      path: '',
      name: 'CourtOfJusticeView',
      component: () => import('./views/CourtOfJusticeView.vue'),
      meta: {
        title: 'courtOfJustice.courtOfJusticeClaims',
      },
    },
    {
      path: 'create',
      name: 'CourtOfJusticeCreateView',
      component: () => import('./views/CourtOfJusticeUpsertView.vue'),
      meta: {
        title: 'courtOfJustice.createProperty',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:courtOfJusticeId',
      name: 'CourtOfJusticeEditView',
      component: () => import('./views/CourtOfJusticeUpsertView.vue'),
      meta: {
        title: 'courtOfJustice.editProperty',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:courtOfJusticeId',
      name: 'CourtOfJusticeSingleView',
      component: () => import('./views/CourtOfJusticeSingleView.vue'),
      meta: {
        title: 'courtOfJustice.ViewProperty',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(courtOfJusticeRoutes)
}
